import { fetchData } from 'lib/fetchData';
import { withSessionSsr } from 'lib/withSession';
import type { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import * as React from 'react';
import { API } from '_helpers';
import Wrapper from '../../components/wrapper/Wrapper';

const Header = dynamic(import('components/header'));
const ProfileLayout = dynamic(
  import('components/dev/components/profileLayout')
);

interface IProps {
  menu: any;
  company: any;
  header: any;
  footer: any;
  seo: any;
  developer: any;
}

const Profile: NextPage<IProps> = (props) => {
  const { menu, company, footer, header, seo, developer } = props;

  return (
    <Wrapper menu={menu} company={company} footer={footer}>
      <Head>
        <meta name="description" content={seo.pages[0].description} />
        <link rel="icon" href={API + company.favicon.media.url} />
        <meta
          property="article:published_time"
          content={new Date().toLocaleTimeString()}
        />
        <meta
          name="publish_date"
          property="og:publish_date"
          content={new Date().toLocaleDateString()}
        />
        <meta
          name="author"
          property="article:author"
          content="Luccin Masirika"
        />
        <meta
          name="robots"
          content="noimageindex, noindex, nofollow, nosnippet"
        />
      </Head>
      <Header data={header.dev} />
      <ProfileLayout data={developer} />
    </Wrapper>
  );
};

export const getServerSideProps: GetServerSideProps = withSessionSsr(
  async (context) => {
    const { locale, req } = context;
    const auth = req.session?.user;

    if (!req.session?.user) {
      return {
        redirect: {
          destination: '/dev/login',
          permanent: false,
        },
      };
    }

    const menu = await fetchData(`/menu/?_locale=${locale}`);
    const company = await fetchData(`/company/?_locale=${locale}`);
    const footer = await fetchData(`/footer/?_locale=${locale}`);
    const header = await fetchData(`/headers/?_locale=${locale}`);
    const seo = await fetchData(`/seo/?_locale=${locale}`);
    const developer = await fetchData(
      `/developers/${
        auth?.user?.developer ? auth?.user?.developer?._id : auth?.user
      }`
    );

    if (!developer?._id) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        menu,
        company,
        footer,
        header,
        seo,
        developer: { ...developer, jwt: auth?.jwt },
      },
    };
  }
);

export default Profile;
